(function () {
  'use strict';

  var pdp = document.querySelector('.summit-pdp');
  if (!pdp) return;

  var dataEl  = document.getElementById('summit-pdp-data');
  var pdpData = dataEl ? JSON.parse(dataEl.textContent) : {};

  var imgTrack   = pdp.querySelector('.summit-pdp__img-track');
  var imgPrev    = pdp.querySelector('.summit-pdp__img-prev');
  var imgNext    = pdp.querySelector('.summit-pdp__img-next');
  var imageWrap  = pdp.querySelector('.summit-pdp__image-wrap');
  var infoDetail = pdp.querySelector('.summit-pdp__info-detail');
  var infoToggle = pdp.querySelector('.summit-pdp__info-toggle');
  var addBtn     = pdp.querySelector('.summit-pdp__add-btn');
  var chipsEl    = pdp.querySelector('.summit-pdp__size-chips');
  var statusEl   = pdp.querySelector('.summit-pdp__status');
  var priceEl    = pdp.querySelector('.summit-pdp__price');
  var backBtn    = document.getElementById('summit-pdp-back');

  var imgCount      = pdpData.imageCount || 0;
  var imgIdx        = 0;
  var hasRealSizes  = pdpData.hasRealSizes || false;
  var defaultVarId  = pdpData.defaultVariantId || null;

  // ── 戻るボタン ──────────────────────────────────────────────────────
  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (history.length > 1) {
        history.back();
      } else {
        window.location.href = '/';
      }
    });
  }

  // ── 画像ナビ ────────────────────────────────────────────────────────
  function renderImage(idx) {
    idx = Math.max(0, Math.min(imgCount - 1, idx));
    imgIdx = idx;
    if (imgTrack) imgTrack.scrollTo({ left: idx * imgTrack.clientWidth, behavior: 'smooth' });
    var showArrows = imgCount > 1;
    if (imgPrev) {
      imgPrev.style.visibility = showArrows ? '' : 'hidden';
      imgPrev.disabled = idx === 0;
    }
    if (imgNext) {
      imgNext.style.visibility = showArrows ? '' : 'hidden';
      imgNext.disabled = idx === imgCount - 1;
    }
  }

  renderImage(0);

  // scroll-snap によるスワイプ後、矢印状態を同期
  if (imgTrack) {
    imgTrack.addEventListener('scroll', function () {
      var w = imgTrack.clientWidth;
      if (!w) return;
      var newIdx = Math.round(imgTrack.scrollLeft / w);
      if (newIdx === imgIdx) return;
      imgIdx = newIdx;
      if (imgPrev) imgPrev.disabled = imgIdx === 0;
      if (imgNext) imgNext.disabled = imgIdx === imgCount - 1;
    }, { passive: true });
  }

  if (imgPrev) imgPrev.addEventListener('click', function () { renderImage(imgIdx - 1); });
  if (imgNext) imgNext.addEventListener('click', function () { renderImage(imgIdx + 1); });

  // ── MORE INFO トグル ────────────────────────────────────────────────
  if (infoToggle) {
    infoToggle.addEventListener('click', function () {
      var isOpen = imageWrap && imageWrap.classList.contains('is-info-open');
      if (imageWrap)  imageWrap.classList.toggle('is-info-open', !isOpen);
      if (infoDetail) {
        infoDetail.classList.toggle('is-open', !isOpen);
        infoDetail.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      }
      infoToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      infoToggle.textContent = isOpen ? 'MORE INFO' : 'CLOSE INFO';
    });
  }

  // ── ADD TO CART / サイズチップ ──────────────────────────────────────
  // サイズは常時表示。チップクリックで選択（is-selected で◯囲み）し、
  // ADD TO CART 押下で選択中バリアントをカートに追加する。
  var selectedVarId = null;

  function updateAddLabel() {
    if (addBtn) { addBtn.textContent = 'ADD TO CART'; addBtn.disabled = false; }
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span:first-child').forEach(function (el) {
          el.textContent = n;
        });
      })
      .catch(function () {});
  }

  function handleAddToCart(variantId) {
    if (!variantId) return;
    if (addBtn)   { addBtn.textContent = 'ADDING...'; addBtn.disabled = true; }
    if (statusEl) statusEl.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function () {
      if (addBtn) { addBtn.textContent = 'ADDED ✓'; addBtn.disabled = false; }
      refreshCartCount();
      setTimeout(updateAddLabel, 2000);
    })
    .catch(function () {
      updateAddLabel();
      if (statusEl) statusEl.textContent = 'エラーが発生しました。再度お試しください。';
    });
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (hasRealSizes) {
        if (selectedVarId) {
          handleAddToCart(selectedVarId);
        } else if (statusEl) {
          statusEl.textContent = 'サイズを選択してください';
        }
      } else {
        if (defaultVarId) handleAddToCart(defaultVarId);
      }
    });
  }

  // チップクリック: 選択のみ（◯囲み）。カート追加は ADD TO CART で行う。
  // 選択したバリアントの価格（data-price）を価格表示に反映する
  if (chipsEl) {
    chipsEl.addEventListener('click', function (e) {
      var chip = e.target.closest('.summit-pdp__size-chip');
      if (!chip || chip.disabled) return;
      chipsEl.querySelectorAll('.summit-pdp__size-chip').forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      chip.classList.add('is-selected');
      chip.setAttribute('aria-pressed', 'true');
      selectedVarId = parseInt(chip.dataset.variantId, 10) || null;
      if (priceEl && chip.dataset.price) priceEl.textContent = chip.dataset.price + ' yen';
      if (statusEl) statusEl.textContent = '';
    });
  }

  /* ══════════════════════════════════════════════════════════════════════
     カートドロワー（TOPと同一UI）
     ヘッダーのカートアイコン(#cart-icon-bubble)の /cart 遷移を止めて開く
  ══════════════════════════════════════════════════════════════════════ */

  var drawer = document.getElementById('summit-cart-drawer');

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents, fmt) {
    if (!fmt) return String(cents);
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return String(cents);
    var precision = 2, thousands = ',', decimal = '.';
    switch (m[1]) {
      case 'amount_no_decimals':
        precision = 0; break;
      case 'amount_with_comma_separator':
        thousands = '.'; decimal = ','; break;
      case 'amount_no_decimals_with_comma_separator':
        precision = 0; thousands = '.'; decimal = ''; break;
      case 'amount_no_decimals_with_space_separator':
        precision = 0; thousands = ' '; break;
    }
    var num   = (cents / 100.0).toFixed(precision);
    var parts = num.split('.');
    var int   = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var dec   = parts[1] ? decimal + parts[1] : '';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, int + dec);
  }

  var moneyFmt = drawer ? (drawer.dataset.moneyFormat || '') : '';

  function renderCartDrawer() {
    var itemsEl = drawer ? drawer.querySelector('.summit-drawer__items') : null;
    var totalEl = drawer ? drawer.querySelector('.summit-drawer__total') : null;

    if (itemsEl) itemsEl.innerHTML = '<p class="summit-drawer__loading">読み込み中...</p>';

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!itemsEl) return;
      itemsEl.innerHTML = '';

      if (!cart.items || cart.items.length === 0) {
        itemsEl.innerHTML = '<p class="summit-drawer__empty">カートは空です</p>';
        if (totalEl) totalEl.textContent = '';
        return;
      }

      cart.items.forEach(function (item) {
        var div       = document.createElement('div');
        div.className = 'summit-drawer__item';
        var imgSrc    = item.image ? (item.image.startsWith('//') ? 'https:' + item.image : item.image) : '';
        var title     = item.product_title || item.title || '';
        var variant   = (item.variant_title && item.variant_title !== 'Default Title')
                          ? item.variant_title : '';
        var linePrice = formatMoney(item.line_price, moneyFmt);

        var k = escHtml(item.key);
        div.innerHTML =
          '<div class="summit-drawer__item-img-wrap">' +
            (imgSrc ? '<img src="' + escHtml(imgSrc) + '" alt="' + escHtml(title) + '" class="summit-drawer__item-img" loading="lazy">' : '') +
          '</div>' +
          '<div class="summit-drawer__item-info">' +
            '<div class="summit-drawer__item-header">' +
              '<div class="summit-drawer__item-title">' + escHtml(title.toUpperCase()) + '</div>' +
              '<button class="summit-drawer__item-remove" type="button" data-cart-remove="' + k + '" aria-label="削除">✕</button>' +
            '</div>' +
            (variant ? '<div class="summit-drawer__item-variant">' + escHtml(variant.toUpperCase()) + '</div>' : '') +
            '<div class="summit-drawer__item-bottom">' +
              '<div class="summit-drawer__qty-ctrl">' +
                '<button class="summit-drawer__qty-btn" type="button" data-cart-key="' + k + '" data-cart-qty-delta="-1" aria-label="数量を減らす">−</button>' +
                '<span class="summit-drawer__qty-num">' + item.quantity + '</span>' +
                '<button class="summit-drawer__qty-btn" type="button" data-cart-key="' + k + '" data-cart-qty-delta="1" aria-label="数量を増やす">+</button>' +
              '</div>' +
              '<span class="summit-drawer__item-price">' + escHtml(linePrice) + '</span>' +
            '</div>' +
          '</div>';

        itemsEl.appendChild(div);
      });

      if (totalEl) {
        totalEl.textContent = 'TOTAL  ' + formatMoney(cart.total_price, moneyFmt);
      }
    })
    .catch(function () {
      if (itemsEl) itemsEl.innerHTML = '<p class="summit-drawer__empty">読み込みエラー</p>';
    });
  }

  function cartChange(key, quantity) {
    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      renderCartDrawer();
      refreshCartCount();
    })
    .catch(function () {});
  }

  function openCartDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    renderCartDrawer();
    var closeBtn = drawer.querySelector('.summit-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeCartDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
  }

  if (drawer) {
    var drawerBackdrop = drawer.querySelector('.summit-drawer__backdrop');
    var drawerClose    = drawer.querySelector('.summit-drawer__close');
    if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeCartDrawer);
    if (drawerClose)    drawerClose.addEventListener('click', closeCartDrawer);

    // 数量変更・削除: パネルへの委譲（innerHTML 更新後も有効）
    var drawerPanel = drawer.querySelector('.summit-drawer__panel');
    if (drawerPanel) {
      drawerPanel.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn) {
          cartChange(removeBtn.dataset.cartRemove, 0);
          return;
        }
        var qtyBtn = e.target.closest('[data-cart-qty-delta]');
        if (qtyBtn) {
          var ctrl       = qtyBtn.closest('.summit-drawer__qty-ctrl');
          var numEl      = ctrl && ctrl.querySelector('.summit-drawer__qty-num');
          var currentQty = numEl ? parseInt(numEl.textContent, 10) : 1;
          var delta      = parseInt(qtyBtn.dataset.cartQtyDelta, 10);
          var newQty     = Math.max(0, currentQty + delta);
          cartChange(qtyBtn.dataset.cartKey, newQty);
        }
      });
    }

    // ヘッダーのカートアイコン: /cart への遷移を止めてドロワーを開く
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    }

    // Escape でドロワーを閉じる
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });
  }
})();
